/**
 * AI 聊天混入
 * 用于在多个页面中方便地使用 AI 聊天功能
 */
export default {
  computed: {
    // 检查 AI 聊天是否可用
    isAIChatEnabled() {
      return this.$store.getters.isAIChatEnabled;
    },
    // 获取当前报告编号
    getCurrentPackageNo() {
      return this.$store.getters.getCurrentPackageNo;
    },
    // 检查 AI 解读是否完成
    isAIInterpretCompleted() {
      return this.$store.getters.isAIInterpretCompleted;
    }
  },
  methods: {
    // 重置 AI 状态（切换报告时调用）
    resetAIState() {
      this.$store.commit('RESET_AI_STATE');
    },
    // 设置 AI 解读完成状态
    setAIInterpretCompleted(packageNo, completed = true) {
      this.$store.commit('SET_AI_INTERPRET_COMPLETED', {
        completed,
        packageNo
      });
    },
    // 检查是否可以使用 AI 聊天
    checkAIChatAvailable() {
      if (!this.isAIChatEnabled) {
        this.$showToast('请等待AI解读完成后再使用聊天功能');
        return false;
      }
      return true;
    }
  }
};